<script setup>
</script>
<template>
  <div class="a bj mt-[64px]">
    <div class="a bk bl bm bn bo bp">
      <div class="a bq au ar br bs">
        <a
          style="cursor: pointer; text-decoration: none; color: #6a6a6a"
          href="/"
          >Home</a
        >
        <div style="padding: 0 8px">/</div>
        <a
          style="cursor: pointer; text-decoration: none; color: #6a6a6a"
          href="/calculator"
          >Calculators</a
        >
        <div style="padding: 0 8px">/</div>
        <div style="color: #101010">Trade Price Checker</div>
      </div>
    </div>
    <div class="c a bk bl bt bm bu bv bp">
      <div class="bw bx by bz bn">
        <h1 class="ca cb bw cc cd ce">Trade Price Checker</h1>
        <div
          style="
            display: inline-block;
            max-width: 100%;
            overflow: hidden;
            position: relative;
            box-sizing: border-box;
            margin: 0;
          "
        >
          <div style="box-sizing: border-box; display: block; max-width: 100%">
            <img
              style="
                max-width: 100%;
                display: block;
                margin: 0;
                border: none;
                padding: 0;
              "
              alt=""
              aria-hidden="true"
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTA5IiBoZWlnaHQ9IjE2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIvPg=="
            />
          </div>
          <img
            alt="TBT"
            src="@/styles/img/calculator/trade-price-checker/TBTText.svg"
            decoding="async"
            data-nimg="intrinsic"
            style="
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              box-sizing: border-box;
              padding: 0;
              border: none;
              margin: auto;
              display: block;
              width: 0;
              height: 0;
              min-width: 100%;
              max-width: 100%;
              min-height: 100%;
              max-height: 100%;
            "
          /><noscript
            ><img
              alt="TBT"
              src="/calculator/trade-price-checker/TBTText.svg"
              decoding="async"
              data-nimg="intrinsic"
              style="
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                box-sizing: border-box;
                padding: 0;
                border: none;
                margin: auto;
                display: block;
                width: 0;
                height: 0;
                min-width: 100%;
                max-width: 100%;
                min-height: 100%;
                max-height: 100%;
              "
              loading="eager"
          /></noscript>
        </div>
        <h2 class="f cf bw cc cd cg ch bz ci cj ck cl">
          Verify NSE trades placed across brokers
        </h2>
        <div class="a ii cc cn co">
          <div class="a bj cp cq">
            <span class="bw g f cd cg cr cs"
              >Segment (NSE)<span class="ct">*</span>
            </span>
            <div class="a cu cv cc cw">
              <button
                type="button"
                style="
                  border-radius: 0px;
                  height: 40px;
                  width: 100%;
                  padding: 0px 24px;
                "
                class="at e f x y c av ab aw i a ae af ag ah ai az ba bb bc bd be bf n bg bh bi"
              >
                Equity</button
              ><button
                type="button"
                style="
                  border-radius: 0px;
                  height: 40px;
                  width: 100%;
                  padding: 0px 24px;
                "
                class="cx e f x y c z ab aw i a ae af ag ah ai aj ba cy bc an be m n ap bh o"
              >
                F&amp;O</button
              ><button
                type="button"
                style="
                  border-radius: 0px;
                  height: 40px;
                  width: 100%;
                  padding: 0px 24px;
                "
                class="cx e f x y c z ab aw i a ae af ag ah ai aj ba cy bc an be m n ap bh o"
              >
                Currency
              </button>
            </div>
          </div>
          <div class="a bj cz">
            <div class="c a cm">
              <span class="bw g f cd cg cr cs"
                >Trade Date<span class="ct">*</span></span
              >
            </div>
            <div class="a cw cv da db dc">
              <div class="inputDate dd de ay df dg dh c di cm">
                <div class="c a cm dj dk dl dm">
                  <input
                    type="date"
                    label="Trade Date"
                    placeholder="Select Date"
                    value="2025-03-01"
                    style="border-radius: 4px; width: 206px"
                    max="2025-03-01"
                    min="2025-02-22"
                    class="q e f ar dn de cc do dp dq dr m ds dt du dv dw dx dy a"
                  />
                  <div class="dz cv ea eb ec ed ee ef eg eh ei"></div>
                  <div class="a"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="a ej ek">
          <span class="au el ar br em"
            >Search trade data spanning from the previous 30 minutes to the last
            7 days</span
          >
        </div>
        <div class="c a ij">
          <div class="c a eo ep eq er">
            <span class="es et eu df ev"
              ><input
                type="radio"
                id="checkbox-input"
                checked=""
                class="ew ex i ey ez ee cc fa fb fc fd fe ff fg fh fi fj fk" /><svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
                class="q fl fm"
              >
                <defs></defs>
                <path
                  fill="currentColor"
                  d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm0 1.692a9.308 9.308 0 100 18.616 9.308 9.308 0 000-18.616z"
                ></path></svg
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
                class="q fl fm"
              >
                <defs></defs>
                <g fill="currentColor">
                  <path
                    d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm0 1.692a9.308 9.308 0 100 18.616 9.308 9.308 0 000-18.616z"
                  ></path>
                  <path d="M18 12a6 6 0 10-12 0 6 6 0 0012 0z"></path>
                </g></svg></span
            ><span class="au ci cf br">Search with Scrip Name &amp; Price</span>
          </div>
        </div>
        <div style="width: 100%" class="gc a fn">
          <div class="gc a dj dk dl dm">
            <div class="a ik bn">
              <div class="a ik dj dk dl dm">
                <div class="a bj">
                  <span class="bw g f cd cg cr cs"
                    >Scrip Name<span class="ct">*</span></span
                  >
                  <div class="a df cw cv da fo fp">
                    <div class="dd de ay df dg dh c di cm">
                      <div class="c a cm dj dk dl dm">
                        <input
                          type="text"
                          placeholder="Enter scrip name"
                          value=""
                          style="width: 232px"
                          class="q e f ar dn de cc do dp dq dr m ds dt du dv dw dx dy a"
                        />
                        <div class="dz cv ea eb ec ed ee ef eg eh ei"></div>
                        <div class="a">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            aria-hidden="true"
                            focusable="false"
                            class="q fq fr"
                          >
                            <defs></defs>
                            <path
                              stroke="currentColor"
                              stroke-width="2"
                              d="M22 22l-7-7m2-5.5a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z"
                            ></path>
                          </svg>
                        </div>
                        <div class="a"></div>
                      </div>
                    </div>
                    <div class="a ee fs de ef eg"></div>
                  </div>
                </div>
                <div class="a bj">
                  <span class="bw g f cd cg cr cs"
                    >Price<span class="ct">*</span></span
                  >
                  <div class="a cw cv da db">
                    <div class="dd de ay df dg dh c di cm">
                      <div class="c a cm dj dk dl dm">
                        <input
                          type="number"
                          label="Price"
                          placeholder="Enter Price"
                          style="width: 215px"
                          value=""
                          class="q e f ar dn de cc do dp dq dr m ds dt du dv dw dx dy a"
                        />
                        <div class="dz cv ea eb ec ed ee ef eg eh ei"></div>
                        <div class="a"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="c a ft cc">
          <div class="c a fu fv fw fx">
            <hr aria-hidden="true" style="width: 100%" class="fy fz ez" />
            <span class="bs ga cf br">OR</span>
            <hr aria-hidden="true" style="width: 100%" class="fy fz ez" />
          </div>
        </div>
        <div class="c a ij">
          <div class="c a eo ep eq er">
            <span class="es et eu df ev"
              ><input
                type="radio"
                id="checkbox-input"
                style="
                  border: 2px solid #6a6a6a;
                  border-radius: 50%;
                  z-index: 1;
                "
                class="ew ex i ey ez ee cc fa fb fc fd fe ff fg fh fi fj fk" /><svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
                class="q fl fm"
              >
                <defs></defs>
                <path
                  fill="currentColor"
                  d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm0 1.692a9.308 9.308 0 100 18.616 9.308 9.308 0 000-18.616z"
                ></path></svg
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
                class="q fl fm"
              >
                <defs></defs>
                <g fill="currentColor">
                  <path
                    d="M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm0 1.692a9.308 9.308 0 100 18.616 9.308 9.308 0 000-18.616z"
                  ></path>
                  <path d="M18 12a6 6 0 10-12 0 6 6 0 0012 0z"></path>
                </g></svg></span
            ><span class="au ci cf br">Search with Exchange No.</span>
          </div>
        </div>
        <div class="gc a cc cn co">
          <div class="gc a dj dk dl dm">
            <div class="a bj bn">
              <div style="margin-bottom: 8px" class="c a">
                <div class="c a gd ge gf gg">
                  <span class="bw g f cd cg gh cs"
                    >Exchange No.<span class="ct">*</span></span
                  >
                  <div class="a">
                    <div class="styles_tooltipInfo__3qKW3 a">
                      <div class="styles_tooltipIcon__1cKvh a">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 16 16"
                          aria-hidden="true"
                          focusable="false"
                          style="margin-right: 6px; width: 12px"
                          class="styles_tooltipContainer__3EHPT q fq fr"
                        >
                          <defs></defs>
                          <path
                            fill="currentColor"
                            d="M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 3.28a1.04 1.04 0 110 2.08 1.04 1.04 0 010-2.08zm2.56 9.04h-4.8v-1.28h1.76V7.52H6.24V6.24H8.8v4.8h1.76z"
                          ></path>
                        </svg>
                      </div>
                      <div class="styles_tooltiptext__16TQQ dy a bj">
                        <div class="dy a">
                          <span style="margin-left: auto" class="gi e f ar h"
                            >Exchange No. is a unique identification code for
                            all trades place on NSE.</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="a gj cv da db">
                <div class="dd de ay df dg dh c di cm">
                  <div class="c a cm dj dk dl dm">
                    <input
                      type="text"
                      disabled=""
                      placeholder="Enter Exchange No."
                      value=""
                      style="width: 244px"
                      class="q e f ar dn de cc do dp dq dr m ds dt du dv dw dx dy a"
                    />
                    <div class="dz cv ea eb ec ed ee ef eg eh ei"></div>
                    <div class="a"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="a cm gk cc cn co">
          <div class="a cm fu fv fw fx">
            <button
              type="button"
              style="border-radius: 8px; height: 40px; width: 250px"
              class="q e f x y c z ab ac i a ae af ag ah ai aj ak al am an ao m n ap aq o"
            >
              <span class="q e f ar h">Reset</span></button
            ><button
              type="button"
              style="
                border-radius: 4px;
                height: 40px;
                opacity: 0.5;
                cursor: not-allowed;
                width: 400px;
              "
              class="at e f x y c av ab aw i a ae af ag ah ai az ba bb bc bd be bf n bg bh bi"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div class="il im cv in io ip iq ir is">
        <div class="a bj it">
          <div class="a bj">
            <div class="a bj eo ep eq er">
              <div class="a bj ij">
                <span class="iu d g iv iw hq ix iy"
                  >For Accurate &amp; Reliable Triggers</span
                >
              </div>
              <hr aria-hidden="true" class="fy iz ez" />
              <div class="a bj">
                <span class="f ja g cg hq jb jc"
                  >Open a FREE* Demat + Trading account</span
                >
              </div>
              <div class="a bj">
                <div class="a bj eo ep eq er">
                  <span class="au ja cf br hq">ZERO AMC</span
                  ><span class="au ja cf br hq"
                    >₹20* per order on Equity, F&amp;O, Currency and
                    Commodity</span
                  >
                </div>
              </div>
            </div>
          </div>
          <hr aria-hidden="true" class="fy iz ez" />
          <div class="a bj">
            <div class="a bj eo ep eq er">
              <span class="f q g cg hq"
                >Enter your mobile number to continue</span
              >
              <div class="a bj">
                <div class="a bj eo ep eq er">
                  <label class="q e f g h"></label>
                  <div class="dd de ay df dg dh c di cm">
                    <div class="c a cm dj dk dl dm">
                      <div class="a">
                        <div class="c a af">
                          <div class="c a af jd je jf jg">
                            <span class="bs e f g h">+91</span>
                          </div>
                        </div>
                      </div>
                      <input
                        type="text"
                        id="mobileNum"
                        maxlength="10"
                        class="q e f ar dn de cc do dp dq if m ds ig du dv ih dx dy a"
                        value=""
                      />
                      <div class="dz cv ea eb ec ed ee ef eg eh ei"></div>
                      <div class="a"></div>
                    </div>
                  </div>
                  <span data-qa="info-message" class="bs e au ar id"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="a bj jh ji">
            <div class="a bj jd je jf jg">
              <button
                type="button"
                disabled=""
                class="at e f x y c av ab aw i a ae af ag ah ai cc az ie bb bc bd be bf n bg bh bi"
                style="font-size: 14px; border-radius: 32px; height: 40px"
              >
                Start Investing</button
              ><span class="by ga cf br jj"
                >By signing up, you agree our
                <a
                  href="/terms-of-use-and-privacy-policy/"
                  target="_blank"
                  style="
                    color: rgb(102, 102, 102);
                    font-weight: 700;
                    text-decoration: underline;
                  "
                  >Terms and Conditions</a
                ></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="a bk gl gm gn">
    <div class="a bj bx go gn gp">
      <div class="styles_separator__3SbL9">
        <hr aria-hidden="true" class="styles_divider__1W9-k fy gq ez" />
        <div class="styles_resultHeading__1AT04">
          Search to get results below
        </div>
        <hr aria-hidden="true" class="styles_divider__1W9-k fy gq ez" />
      </div>
      <div class="styles_chartContainer__3opLv">
        <div class="styles_chartInfoWrapper__TzZ9U">
          <div>
            <div class="styles_scripHeading__2akZx">
              <p>Stock Name</p>
              <div class="styles_darkDot__1jq_w"></div>
              <p>₹Entered Price</p>
            </div>
            <div class="styles_scripSubHeading__1h2tq">
              <p>Segment</p>
              <div class="styles_lightDot__3Nzx1"></div>
              <p>Date</p>
            </div>
          </div>
        </div>
        <div class="styles_scrollContainer__FH9Qr">
          <div class="styles_blur__71O09">
            <div class="c a bj af">
              <div
                style="
                  height: 100%;
                  width: 100%;
                  user-select: none;
                  pointer-events: none;
                  touch-action: none;
                  position: relative;
                "
                class="VictoryContainer"
              >
                <svg
                  width="740"
                  height="270"
                  role="img"
                  viewBox="0 0 740 270"
                  style="pointer-events: all; width: 100%; height: 100%"
                >
                  <g role="presentation">
                    <line
                      vector-effect="non-scaling-stroke"
                      style="
                        stroke: #444;
                        fill: transparent;
                        stroke-width: 1;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
                      role="presentation"
                      shape-rendering="auto"
                      x1="50"
                      x2="690"
                      y1="220"
                      y2="220"
                    ></line>
                    <text
                      direction="inherit"
                      dx="0"
                      x="370"
                      y="266.26"
                      id="chart-axis-0-axisLabel-0"
                    >
                      <tspan
                        x="370"
                        dx="0"
                        dy="0"
                        text-anchor="middle"
                        style="
                          font-size: 12px;
                          margin: 10px;
                          font-weight: 400;
                          padding: 36px;
                          text-anchor: middle;
                          font-family: 'Gill Sans', 'Seravek', 'Trebuchet MS',
                            sans-serif;
                          letter-spacing: normal;
                          fill: #252525;
                          stroke: transparent;
                        "
                      >
                        Market timings(15 min intervals)
                      </tspan>
                    </text>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="52"
                        y="243.1275"
                        transform="rotate(-40,52,231)"
                        id="chart-axis-0-tickLabels-0"
                      >
                        <tspan
                          x="52"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          09:00
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="71.875"
                        y="243.1275"
                        transform="rotate(-40,71.875,231)"
                        id="chart-axis-0-tickLabels-1"
                      >
                        <tspan
                          x="71.875"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          09:15
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="91.74999999999999"
                        y="243.1275"
                        transform="rotate(-40,91.74999999999999,231)"
                        id="chart-axis-0-tickLabels-2"
                      >
                        <tspan
                          x="91.74999999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          09:30
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="111.62499999999999"
                        y="243.1275"
                        transform="rotate(-40,111.62499999999999,231)"
                        id="chart-axis-0-tickLabels-3"
                      >
                        <tspan
                          x="111.62499999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          09:45
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="131.5"
                        y="243.1275"
                        transform="rotate(-40,131.5,231)"
                        id="chart-axis-0-tickLabels-4"
                      >
                        <tspan
                          x="131.5"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          10:00
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="151.37499999999997"
                        y="243.1275"
                        transform="rotate(-40,151.37499999999997,231)"
                        id="chart-axis-0-tickLabels-5"
                      >
                        <tspan
                          x="151.37499999999997"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          10:15
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="171.24999999999997"
                        y="243.1275"
                        transform="rotate(-40,171.24999999999997,231)"
                        id="chart-axis-0-tickLabels-6"
                      >
                        <tspan
                          x="171.24999999999997"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          10:30
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="191.12499999999997"
                        y="243.1275"
                        transform="rotate(-40,191.12499999999997,231)"
                        id="chart-axis-0-tickLabels-7"
                      >
                        <tspan
                          x="191.12499999999997"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          10:45
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="210.99999999999997"
                        y="243.1275"
                        transform="rotate(-40,210.99999999999997,231)"
                        id="chart-axis-0-tickLabels-8"
                      >
                        <tspan
                          x="210.99999999999997"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          11:00
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="230.87499999999994"
                        y="243.1275"
                        transform="rotate(-40,230.87499999999994,231)"
                        id="chart-axis-0-tickLabels-9"
                      >
                        <tspan
                          x="230.87499999999994"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          11:15
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="250.74999999999994"
                        y="243.1275"
                        transform="rotate(-40,250.74999999999994,231)"
                        id="chart-axis-0-tickLabels-10"
                      >
                        <tspan
                          x="250.74999999999994"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          11:30
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="270.625"
                        y="243.1275"
                        transform="rotate(-40,270.625,231)"
                        id="chart-axis-0-tickLabels-11"
                      >
                        <tspan
                          x="270.625"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          11:45
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="290.49999999999994"
                        y="243.1275"
                        transform="rotate(-40,290.49999999999994,231)"
                        id="chart-axis-0-tickLabels-12"
                      >
                        <tspan
                          x="290.49999999999994"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          12:00
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="310.37499999999994"
                        y="243.1275"
                        transform="rotate(-40,310.37499999999994,231)"
                        id="chart-axis-0-tickLabels-13"
                      >
                        <tspan
                          x="310.37499999999994"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          12:15
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="330.24999999999994"
                        y="243.1275"
                        transform="rotate(-40,330.24999999999994,231)"
                        id="chart-axis-0-tickLabels-14"
                      >
                        <tspan
                          x="330.24999999999994"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          12:30
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="350.12499999999994"
                        y="243.1275"
                        transform="rotate(-40,350.12499999999994,231)"
                        id="chart-axis-0-tickLabels-15"
                      >
                        <tspan
                          x="350.12499999999994"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          12:45
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="369.99999999999994"
                        y="243.1275"
                        transform="rotate(-40,369.99999999999994,231)"
                        id="chart-axis-0-tickLabels-16"
                      >
                        <tspan
                          x="369.99999999999994"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          13:00
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="389.8749999999999"
                        y="243.1275"
                        transform="rotate(-40,389.8749999999999,231)"
                        id="chart-axis-0-tickLabels-17"
                      >
                        <tspan
                          x="389.8749999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          13:15
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="409.74999999999994"
                        y="243.1275"
                        transform="rotate(-40,409.74999999999994,231)"
                        id="chart-axis-0-tickLabels-18"
                      >
                        <tspan
                          x="409.74999999999994"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          13:30
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="429.6249999999999"
                        y="243.1275"
                        transform="rotate(-40,429.6249999999999,231)"
                        id="chart-axis-0-tickLabels-19"
                      >
                        <tspan
                          x="429.6249999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          13:45
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="449.4999999999999"
                        y="243.1275"
                        transform="rotate(-40,449.4999999999999,231)"
                        id="chart-axis-0-tickLabels-20"
                      >
                        <tspan
                          x="449.4999999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          14:00
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="469.37499999999994"
                        y="243.1275"
                        transform="rotate(-40,469.37499999999994,231)"
                        id="chart-axis-0-tickLabels-21"
                      >
                        <tspan
                          x="469.37499999999994"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          14:15
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="489.2499999999999"
                        y="243.1275"
                        transform="rotate(-40,489.2499999999999,231)"
                        id="chart-axis-0-tickLabels-22"
                      >
                        <tspan
                          x="489.2499999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          14:30
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="509.1249999999999"
                        y="243.1275"
                        transform="rotate(-40,509.1249999999999,231)"
                        id="chart-axis-0-tickLabels-23"
                      >
                        <tspan
                          x="509.1249999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          14:45
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="528.9999999999999"
                        y="243.1275"
                        transform="rotate(-40,528.9999999999999,231)"
                        id="chart-axis-0-tickLabels-24"
                      >
                        <tspan
                          x="528.9999999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          15:00
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="548.8749999999999"
                        y="243.1275"
                        transform="rotate(-40,548.8749999999999,231)"
                        id="chart-axis-0-tickLabels-25"
                      >
                        <tspan
                          x="548.8749999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          15:15
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="568.7499999999999"
                        y="243.1275"
                        transform="rotate(-40,568.7499999999999,231)"
                        id="chart-axis-0-tickLabels-26"
                      >
                        <tspan
                          x="568.7499999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          15:30
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="588.6249999999999"
                        y="243.1275"
                        transform="rotate(-40,588.6249999999999,231)"
                        id="chart-axis-0-tickLabels-27"
                      >
                        <tspan
                          x="588.6249999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          15:45
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="608.4999999999999"
                        y="243.1275"
                        transform="rotate(-40,608.4999999999999,231)"
                        id="chart-axis-0-tickLabels-28"
                      >
                        <tspan
                          x="608.4999999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          16:00
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="628.3749999999999"
                        y="243.1275"
                        transform="rotate(-40,628.3749999999999,231)"
                        id="chart-axis-0-tickLabels-29"
                      >
                        <tspan
                          x="628.3749999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          16:15
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="648.2499999999999"
                        y="243.1275"
                        transform="rotate(-40,648.2499999999999,231)"
                        id="chart-axis-0-tickLabels-30"
                      >
                        <tspan
                          x="648.2499999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          16:30
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="668.1249999999999"
                        y="243.1275"
                        transform="rotate(-40,668.1249999999999,231)"
                        id="chart-axis-0-tickLabels-31"
                      >
                        <tspan
                          x="668.1249999999999"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          16:45
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="687.9999999999998"
                        y="243.1275"
                        transform="rotate(-40,687.9999999999998,231)"
                        id="chart-axis-0-tickLabels-32"
                      >
                        <tspan
                          x="687.9999999999998"
                          dx="0"
                          dy="0"
                          text-anchor="middle"
                          style="
                            angle: -40px;
                            font-size: 10.5px;
                            line-height: 16;
                            font-weight: 400;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            padding: 10px;
                            fill: #252525;
                            stroke: transparent;
                          "
                        >
                          17:00
                        </tspan>
                      </text>
                    </g>
                  </g>
                  <g role="presentation">
                    <line
                      vector-effect="non-scaling-stroke"
                      style="
                        stroke: transparent;
                        fill: transparent;
                        stroke-width: 1;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                      "
                      role="presentation"
                      shape-rendering="auto"
                      x1="50"
                      x2="50"
                      y1="50"
                      y2="220"
                    ></line>
                    <text
                      direction="inherit"
                      dx="0"
                      x="14"
                      y="133.057"
                      transform="rotate(-90,14,135)"
                      id="chart-axis-1-axisLabel-0"
                    >
                      <tspan
                        x="14"
                        dx="0"
                        dy="0"
                        text-anchor="middle"
                        style="
                          font-size: 13.4px;
                          font-weight: 400;
                          padding: 36px;
                          text-anchor: middle;
                          font-family: 'Gill Sans', 'Seravek', 'Trebuchet MS',
                            sans-serif;
                          letter-spacing: normal;
                          fill: #252525;
                          stroke: transparent;
                        "
                      >
                        No. of trades
                      </tspan>
                    </text>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="49"
                        y="223.905"
                        id="chart-axis-1-tickLabels-0"
                      >
                        <tspan
                          x="49"
                          dx="0"
                          dy="0"
                          text-anchor="end"
                          style="
                            font-size: 11px;
                            font-weight: 400;
                            padding: 0;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            fill: #252525;
                            stroke: transparent;
                            line-height: 16px;
                          "
                        >
                          0
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="49"
                        y="198.8642252803262"
                        id="chart-axis-1-tickLabels-1"
                      >
                        <tspan
                          x="49"
                          dx="0"
                          dy="0"
                          text-anchor="end"
                          style="
                            font-size: 11px;
                            font-weight: 400;
                            padding: 0;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            fill: #252525;
                            stroke: transparent;
                            line-height: 16px;
                          "
                        >
                          5
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="49"
                        y="173.8234505606524"
                        id="chart-axis-1-tickLabels-2"
                      >
                        <tspan
                          x="49"
                          dx="0"
                          dy="0"
                          text-anchor="end"
                          style="
                            font-size: 11px;
                            font-weight: 400;
                            padding: 0;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            fill: #252525;
                            stroke: transparent;
                            line-height: 16px;
                          "
                        >
                          10
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="49"
                        y="148.7826758409786"
                        id="chart-axis-1-tickLabels-3"
                      >
                        <tspan
                          x="49"
                          dx="0"
                          dy="0"
                          text-anchor="end"
                          style="
                            font-size: 11px;
                            font-weight: 400;
                            padding: 0;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            fill: #252525;
                            stroke: transparent;
                            line-height: 16px;
                          "
                        >
                          15
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="49"
                        y="123.74190112130479"
                        id="chart-axis-1-tickLabels-4"
                      >
                        <tspan
                          x="49"
                          dx="0"
                          dy="0"
                          text-anchor="end"
                          style="
                            font-size: 11px;
                            font-weight: 400;
                            padding: 0;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            fill: #252525;
                            stroke: transparent;
                            line-height: 16px;
                          "
                        >
                          20
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="49"
                        y="98.701126401631"
                        id="chart-axis-1-tickLabels-5"
                      >
                        <tspan
                          x="49"
                          dx="0"
                          dy="0"
                          text-anchor="end"
                          style="
                            font-size: 11px;
                            font-weight: 400;
                            padding: 0;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            fill: #252525;
                            stroke: transparent;
                            line-height: 16px;
                          "
                        >
                          25
                        </tspan>
                      </text>
                    </g>
                    <g role="presentation">
                      <text
                        direction="inherit"
                        dx="0"
                        x="49"
                        y="73.6603516819572"
                        id="chart-axis-1-tickLabels-6"
                      >
                        <tspan
                          x="49"
                          dx="0"
                          dy="0"
                          text-anchor="end"
                          style="
                            font-size: 11px;
                            font-weight: 400;
                            padding: 0;
                            font-family: Messina Sans;
                            letter-spacing: normal;
                            fill: #252525;
                            stroke: transparent;
                            line-height: 16px;
                          "
                        >
                          30
                        </tspan>
                      </text>
                    </g>
                  </g>
                  <g role="presentation">
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 49.75, 220 
A 0 0 0 0 0, 49.75, 220 
L 49.75, 220 
A 0 0 0 0 0, 49.75, 220 
L 54.25, 220 
A 0 0 0 0 0, 54.25, 220 
L 54.25, 220 
A 0 0 0 0 0, 54.25, 220 
 z"
                      index="0"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 69.625, 220 
A 0 0 0 0 0, 69.625, 220 
L 69.625, 220 
A 0 0 0 0 0, 69.625, 220 
L 74.125, 220 
A 0 0 0 0 0, 74.125, 220 
L 74.125, 220 
A 0 0 0 0 0, 74.125, 220 
 z"
                      index="1"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 89.49999999999999, 220 
A 0 0 0 0 0, 89.49999999999999, 220 
L 89.49999999999999, 220 
A 0 0 0 0 0, 89.49999999999999, 220 
L 93.99999999999999, 220 
A 0 0 0 0 0, 93.99999999999999, 220 
L 93.99999999999999, 220 
A 0 0 0 0 0, 93.99999999999999, 220 
 z"
                      index="2"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 109.37499999999999, 220 
A 0 0 0 0 0, 109.37499999999999, 220 
L 109.37499999999999, 220 
A 0 0 0 0 0, 109.37499999999999, 220 
L 113.87499999999999, 220 
A 0 0 0 0 0, 113.87499999999999, 220 
L 113.87499999999999, 220 
A 0 0 0 0 0, 113.87499999999999, 220 
 z"
                      index="3"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 129.25, 220 
A 0 0 0 0 0, 129.25, 220 
L 129.25, 220 
A 0 0 0 0 0, 129.25, 220 
L 133.75, 220 
A 0 0 0 0 0, 133.75, 220 
L 133.75, 220 
A 0 0 0 0 0, 133.75, 220 
 z"
                      index="4"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 149.12499999999997, 220 
A 0 0 0 0 0, 149.12499999999997, 220 
L 149.12499999999997, 220 
A 0 0 0 0 0, 149.12499999999997, 220 
L 153.62499999999997, 220 
A 0 0 0 0 0, 153.62499999999997, 220 
L 153.62499999999997, 220 
A 0 0 0 0 0, 153.62499999999997, 220 
 z"
                      index="5"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 168.99999999999997, 220 
A 0 0 0 0 0, 168.99999999999997, 220 
L 168.99999999999997, 220 
A 0 0 0 0 0, 168.99999999999997, 220 
L 173.49999999999997, 220 
A 0 0 0 0 0, 173.49999999999997, 220 
L 173.49999999999997, 220 
A 0 0 0 0 0, 173.49999999999997, 220 
 z"
                      index="6"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 188.87499999999997, 220 
A 0 0 0 0 0, 188.87499999999997, 220 
L 188.87499999999997, 220 
A 0 0 0 0 0, 188.87499999999997, 220 
L 193.37499999999997, 220 
A 0 0 0 0 0, 193.37499999999997, 220 
L 193.37499999999997, 220 
A 0 0 0 0 0, 193.37499999999997, 220 
 z"
                      index="7"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 208.74999999999997, 220 
A 0 0 0 0 0, 208.74999999999997, 220 
L 208.74999999999997, 220 
A 0 0 0 0 0, 208.74999999999997, 220 
L 213.24999999999997, 220 
A 0 0 0 0 0, 213.24999999999997, 220 
L 213.24999999999997, 220 
A 0 0 0 0 0, 213.24999999999997, 220 
 z"
                      index="8"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 228.62499999999994, 220 
A 0 0 0 0 0, 228.62499999999994, 220 
L 228.62499999999994, 220 
A 0 0 0 0 0, 228.62499999999994, 220 
L 233.12499999999994, 220 
A 0 0 0 0 0, 233.12499999999994, 220 
L 233.12499999999994, 220 
A 0 0 0 0 0, 233.12499999999994, 220 
 z"
                      index="9"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 248.49999999999994, 220 
A 0 0 0 0 0, 248.49999999999994, 220 
L 248.49999999999994, 220 
A 0 0 0 0 0, 248.49999999999994, 220 
L 252.99999999999994, 220 
A 0 0 0 0 0, 252.99999999999994, 220 
L 252.99999999999994, 220 
A 0 0 0 0 0, 252.99999999999994, 220 
 z"
                      index="10"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 268.375, 220 
A 0 0 0 0 0, 268.375, 220 
L 268.375, 220 
A 0 0 0 0 0, 268.375, 220 
L 272.875, 220 
A 0 0 0 0 0, 272.875, 220 
L 272.875, 220 
A 0 0 0 0 0, 272.875, 220 
 z"
                      index="11"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 288.24999999999994, 220 
A 0 0 0 0 0, 288.24999999999994, 220 
L 288.24999999999994, 220 
A 0 0 0 0 0, 288.24999999999994, 220 
L 292.74999999999994, 220 
A 0 0 0 0 0, 292.74999999999994, 220 
L 292.74999999999994, 220 
A 0 0 0 0 0, 292.74999999999994, 220 
 z"
                      index="12"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 308.12499999999994, 220 
A 0 0 0 0 0, 308.12499999999994, 220 
L 308.12499999999994, 220 
A 0 0 0 0 0, 308.12499999999994, 220 
L 312.62499999999994, 220 
A 0 0 0 0 0, 312.62499999999994, 220 
L 312.62499999999994, 220 
A 0 0 0 0 0, 312.62499999999994, 220 
 z"
                      index="13"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 327.99999999999994, 220 
A 0 0 0 0 0, 327.99999999999994, 220 
L 327.99999999999994, 220 
A 0 0 0 0 0, 327.99999999999994, 220 
L 332.49999999999994, 220 
A 0 0 0 0 0, 332.49999999999994, 220 
L 332.49999999999994, 220 
A 0 0 0 0 0, 332.49999999999994, 220 
 z"
                      index="14"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 347.87499999999994, 220 
A 0 0 0 0 0, 347.87499999999994, 220 
L 347.87499999999994, 220 
A 0 0 0 0 0, 347.87499999999994, 220 
L 352.37499999999994, 220 
A 0 0 0 0 0, 352.37499999999994, 220 
L 352.37499999999994, 220 
A 0 0 0 0 0, 352.37499999999994, 220 
 z"
                      index="15"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 367.74999999999994, 220 
A 0 0 0 0 0, 367.74999999999994, 220 
L 367.74999999999994, 220 
A 0 0 0 0 0, 367.74999999999994, 220 
L 372.24999999999994, 220 
A 0 0 0 0 0, 372.24999999999994, 220 
L 372.24999999999994, 220 
A 0 0 0 0 0, 372.24999999999994, 220 
 z"
                      index="16"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 387.6249999999999, 220 
A 0 0 0 0 0, 387.6249999999999, 220 
L 387.6249999999999, 220 
A 0 0 0 0 0, 387.6249999999999, 220 
L 392.1249999999999, 220 
A 0 0 0 0 0, 392.1249999999999, 220 
L 392.1249999999999, 220 
A 0 0 0 0 0, 392.1249999999999, 220 
 z"
                      index="17"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 407.49999999999994, 220 
A 0 0 0 0 0, 407.49999999999994, 220 
L 407.49999999999994, 220 
A 0 0 0 0 0, 407.49999999999994, 220 
L 411.99999999999994, 220 
A 0 0 0 0 0, 411.99999999999994, 220 
L 411.99999999999994, 220 
A 0 0 0 0 0, 411.99999999999994, 220 
 z"
                      index="18"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 427.3749999999999, 220 
A 0 0 0 0 0, 427.3749999999999, 220 
L 427.3749999999999, 220 
A 0 0 0 0 0, 427.3749999999999, 220 
L 431.8749999999999, 220 
A 0 0 0 0 0, 431.8749999999999, 220 
L 431.8749999999999, 220 
A 0 0 0 0 0, 431.8749999999999, 220 
 z"
                      index="19"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 447.2499999999999, 220 
A 0 0 0 0 0, 447.2499999999999, 220 
L 447.2499999999999, 220 
A 0 0 0 0 0, 447.2499999999999, 220 
L 451.7499999999999, 220 
A 0 0 0 0 0, 451.7499999999999, 220 
L 451.7499999999999, 220 
A 0 0 0 0 0, 451.7499999999999, 220 
 z"
                      index="20"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 467.12499999999994, 220 
A 0 0 0 0 0, 467.12499999999994, 220 
L 467.12499999999994, 220 
A 0 0 0 0 0, 467.12499999999994, 220 
L 471.62499999999994, 220 
A 0 0 0 0 0, 471.62499999999994, 220 
L 471.62499999999994, 220 
A 0 0 0 0 0, 471.62499999999994, 220 
 z"
                      index="21"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 486.9999999999999, 220 
A 0 0 0 0 0, 486.9999999999999, 220 
L 486.9999999999999, 220 
A 0 0 0 0 0, 486.9999999999999, 220 
L 491.4999999999999, 220 
A 0 0 0 0 0, 491.4999999999999, 220 
L 491.4999999999999, 220 
A 0 0 0 0 0, 491.4999999999999, 220 
 z"
                      index="22"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 506.8749999999999, 220 
A 0 0 0 0 0, 506.8749999999999, 220 
L 506.8749999999999, 220 
A 0 0 0 0 0, 506.8749999999999, 220 
L 511.3749999999999, 220 
A 0 0 0 0 0, 511.3749999999999, 220 
L 511.3749999999999, 220 
A 0 0 0 0 0, 511.3749999999999, 220 
 z"
                      index="23"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 526.7499999999999, 220 
A 0 0 0 0 0, 526.7499999999999, 220 
L 526.7499999999999, 220 
A 0 0 0 0 0, 526.7499999999999, 220 
L 531.2499999999999, 220 
A 0 0 0 0 0, 531.2499999999999, 220 
L 531.2499999999999, 220 
A 0 0 0 0 0, 531.2499999999999, 220 
 z"
                      index="24"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 546.6249999999999, 220 
A 0 0 0 0 0, 546.6249999999999, 220 
L 546.6249999999999, 220 
A 0 0 0 0 0, 546.6249999999999, 220 
L 551.1249999999999, 220 
A 0 0 0 0 0, 551.1249999999999, 220 
L 551.1249999999999, 220 
A 0 0 0 0 0, 551.1249999999999, 220 
 z"
                      index="25"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 566.4999999999999, 220 
A 0 0 0 0 0, 566.4999999999999, 220 
L 566.4999999999999, 220 
A 0 0 0 0 0, 566.4999999999999, 220 
L 570.9999999999999, 220 
A 0 0 0 0 0, 570.9999999999999, 220 
L 570.9999999999999, 220 
A 0 0 0 0 0, 570.9999999999999, 220 
 z"
                      index="26"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 586.3749999999999, 220 
A 0 0 0 0 0, 586.3749999999999, 220 
L 586.3749999999999, 220 
A 0 0 0 0 0, 586.3749999999999, 220 
L 590.8749999999999, 220 
A 0 0 0 0 0, 590.8749999999999, 220 
L 590.8749999999999, 220 
A 0 0 0 0 0, 590.8749999999999, 220 
 z"
                      index="27"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 606.2499999999999, 220 
A 0 0 0 0 0, 606.2499999999999, 220 
L 606.2499999999999, 220 
A 0 0 0 0 0, 606.2499999999999, 220 
L 610.7499999999999, 220 
A 0 0 0 0 0, 610.7499999999999, 220 
L 610.7499999999999, 220 
A 0 0 0 0 0, 610.7499999999999, 220 
 z"
                      index="28"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 626.1249999999999, 220 
A 0 0 0 0 0, 626.1249999999999, 220 
L 626.1249999999999, 220 
A 0 0 0 0 0, 626.1249999999999, 220 
L 630.6249999999999, 220 
A 0 0 0 0 0, 630.6249999999999, 220 
L 630.6249999999999, 220 
A 0 0 0 0 0, 630.6249999999999, 220 
 z"
                      index="29"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 645.9999999999999, 220 
A 0 0 0 0 0, 645.9999999999999, 220 
L 645.9999999999999, 220 
A 0 0 0 0 0, 645.9999999999999, 220 
L 650.4999999999999, 220 
A 0 0 0 0 0, 650.4999999999999, 220 
L 650.4999999999999, 220 
A 0 0 0 0 0, 650.4999999999999, 220 
 z"
                      index="30"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 665.8749999999999, 220 
A 0 0 0 0 0, 665.8749999999999, 220 
L 665.8749999999999, 220 
A 0 0 0 0 0, 665.8749999999999, 220 
L 670.3749999999999, 220 
A 0 0 0 0 0, 670.3749999999999, 220 
L 670.3749999999999, 220 
A 0 0 0 0 0, 670.3749999999999, 220 
 z"
                      index="31"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                    <path
                      style="
                        fill: #148564;
                        stroke: #148564;
                        width: 4.5px;
                        padding: 8px;
                        stroke-width: 0;
                      "
                      d="M 685.7499999999998, 220 
A 0 0 0 0 0, 685.7499999999998, 220 
L 685.7499999999998, 220 
A 0 0 0 0 0, 685.7499999999998, 220 
L 690.2499999999998, 220 
A 0 0 0 0 0, 690.2499999999998, 220 
L 690.2499999999998, 220 
A 0 0 0 0 0, 690.2499999999998, 220 
 z"
                      index="32"
                      role="presentation"
                      shape-rendering="auto"
                    ></path>
                  </g>
                </svg>
                <div
                  style="
                    z-index: 99;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  "
                >
                  <svg
                    width="740"
                    height="270"
                    viewBox="0 0 740 270"
                    style="overflow: visible; width: 100%; height: 100%"
                  ></svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="a bj gr gs gt">
        <div class="a cu gu gv">
          <table class="z gw gx df gy cc gz ha hb hc hd he hf hg">
            <thead class="hh hi hj">
              <tr class="aw hk hl ci au cf br a c hm hn">
                <th class="ho hp hq"><span class="ci au g br">Sr. No</span></th>
                <th class="ho hp hq">
                  <span class="ci au g br">Time (hh:mm:ss)</span>
                </th>
                <th class="ho hp hq">
                  <span class="ci au g br">No. Of Trades</span>
                </th>
              </tr>
            </thead>
            <tbody class="hr">
              <tr class="ci f ar cg a c hs ht hu">
                <td class="hv hw"><span class="f ar cg">N/A</span></td>
                <td class="hv hw"><span class="f ar cg">N/A</span></td>
                <td class="hv hw"><span class="f ar cg">N/A</span></td>
                <td class="hx i hy">
                  <span class="q e f ar h"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      focusable="false"
                      class="q fl fm"
                    >
                      <defs></defs>
                      <path
                        stroke="currentColor"
                        stroke-width="2"
                        d="M9 5l7 7-7 7"
                      ></path></svg
                  ></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="styles_paginationContainer__2PuU2">
          <ul class="styles_pagination__Pmwkt"></ul>
          <p class="styles_pagesInfo__2OFwh">Showing 1 / 0</p>
        </div>
        <hr
          aria-hidden="true"
          style="width: 100%; margin-top: 20px"
          class="fy hz ez"
        />
      </div>
    </div>
  </div>
  <div class="styles_container__3xsXI">
    <div class="styles_childContainer__1y07r">
      <h2 class="styles_title__3ai7p">How to Use the Trade Price Checker?</h2>
      <div class="styles_tbtText__-PDTU">
        <div
          style="
            display: inline-block;
            max-width: 100%;
            overflow: hidden;
            position: relative;
            box-sizing: border-box;
            margin: 0;
          "
        >
          <div style="box-sizing: border-box; display: block; max-width: 100%">
            <img
              style="
                max-width: 100%;
                display: block;
                margin: 0;
                border: none;
                padding: 0;
              "
              alt=""
              aria-hidden="true"
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTA5IiBoZWlnaHQ9IjE2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIvPg=="
            />
          </div>
          <img
            alt="TBT"
            src="/calculator/trade-price-checker/TBTText.svg"
            decoding="async"
            data-nimg="intrinsic"
            style="
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              right: 0;
              box-sizing: border-box;
              padding: 0;
              border: none;
              margin: auto;
              display: block;
              width: 0;
              height: 0;
              min-width: 100%;
              max-width: 100%;
              min-height: 100%;
              max-height: 100%;
            "
          /><noscript
            ><img
              alt="TBT"
              src="/calculator/trade-price-checker/TBTText.svg"
              decoding="async"
              data-nimg="intrinsic"
              style="
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                box-sizing: border-box;
                padding: 0;
                border: none;
                margin: auto;
                display: block;
                width: 0;
                height: 0;
                min-width: 100%;
                max-width: 100%;
                min-height: 100%;
                max-height: 100%;
              "
              loading="eager"
          /></noscript>
        </div>
      </div>
      <div class="styles_carouselContainer__34YuS">
        <div class="styles_carousel__w1qkn">
          <div
            class="styles_carouselSlide__3npwv styles_slideWidth__1X5an"
            data-slide-number="1"
            style="
              scroll-snap-align: start;
              margin-right: 17px;
              margin-left: 17px;
            "
          >
            <div class="c a af">
              <div class="styles_container__1r8ex">
                <div
                  style="
                    display: inline-block;
                    max-width: 100%;
                    overflow: hidden;
                    position: relative;
                    box-sizing: border-box;
                    margin: 0;
                  "
                >
                  <div
                    style="
                      box-sizing: border-box;
                      display: block;
                      max-width: 100%;
                    "
                  >
                    <img
                      style="
                        max-width: 100%;
                        display: block;
                        margin: 0;
                        border: none;
                        padding: 0;
                      "
                      alt=""
                      aria-hidden="true"
                      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjg4IiBoZWlnaHQ9IjIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiLz4="
                    />
                  </div>
                  <img
                    alt="Step 1"
                    src="/calculator/trade-price-checker/01.webp"
                    decoding="async"
                    data-nimg="intrinsic"
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      bottom: 0;
                      right: 0;
                      box-sizing: border-box;
                      padding: 0;
                      border: none;
                      margin: auto;
                      display: block;
                      width: 0;
                      height: 0;
                      min-width: 100%;
                      max-width: 100%;
                      min-height: 100%;
                      max-height: 100%;
                    "
                  /><noscript
                    ><img
                      alt="Step 1"
                      src="/calculator/trade-price-checker/01.webp"
                      decoding="async"
                      data-nimg="intrinsic"
                      style="
                        position: absolute;
                        top: 0;
                        left: 0;
                        bottom: 0;
                        right: 0;
                        box-sizing: border-box;
                        padding: 0;
                        border: none;
                        margin: auto;
                        display: block;
                        width: 0;
                        height: 0;
                        min-width: 100%;
                        max-width: 100%;
                        min-height: 100%;
                        max-height: 100%;
                      "
                      loading="eager"
                  /></noscript>
                </div>
                <h4 class="styles_step__1U9zH">Step 1</h4>
                <h2 class="styles_title__2GjHQ">Select Segment</h2>
                <p class="styles_info__ed6IV">
                  Choose the trading segment you've engaged in.
                </p>
              </div>
            </div>
          </div>
          <div
            class="styles_carouselSlide__3npwv styles_slideWidth__1X5an"
            data-slide-number="2"
            style="
              scroll-snap-align: start;
              margin-right: 17px;
              margin-left: 17px;
            "
          >
            <div class="c a af">
              <div class="styles_container__1r8ex">
                <div
                  style="
                    display: inline-block;
                    max-width: 100%;
                    overflow: hidden;
                    position: relative;
                    box-sizing: border-box;
                    margin: 0;
                  "
                >
                  <div
                    style="
                      box-sizing: border-box;
                      display: block;
                      max-width: 100%;
                    "
                  >
                    <img
                      style="
                        max-width: 100%;
                        display: block;
                        margin: 0;
                        border: none;
                        padding: 0;
                      "
                      alt=""
                      aria-hidden="true"
                      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjg4IiBoZWlnaHQ9IjIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiLz4="
                    />
                  </div>
                  <img
                    alt="Step 2"
                    src="/calculator/trade-price-checker/02.webp"
                    decoding="async"
                    data-nimg="intrinsic"
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      bottom: 0;
                      right: 0;
                      box-sizing: border-box;
                      padding: 0;
                      border: none;
                      margin: auto;
                      display: block;
                      width: 0;
                      height: 0;
                      min-width: 100%;
                      max-width: 100%;
                      min-height: 100%;
                      max-height: 100%;
                    "
                  /><noscript
                    ><img
                      alt="Step 2"
                      src="/calculator/trade-price-checker/02.webp"
                      decoding="async"
                      data-nimg="intrinsic"
                      style="
                        position: absolute;
                        top: 0;
                        left: 0;
                        bottom: 0;
                        right: 0;
                        box-sizing: border-box;
                        padding: 0;
                        border: none;
                        margin: auto;
                        display: block;
                        width: 0;
                        height: 0;
                        min-width: 100%;
                        max-width: 100%;
                        min-height: 100%;
                        max-height: 100%;
                      "
                      loading="eager"
                  /></noscript>
                </div>
                <h4 class="styles_step__1U9zH">Step 2</h4>
                <h2 class="styles_title__2GjHQ">Choose Date</h2>
                <p class="styles_info__ed6IV">
                  Pick the trade date within the range of data availability (up
                  to 30 mins prior to the current time and up to the last 7
                  trading days).
                </p>
              </div>
            </div>
          </div>
          <div
            class="styles_carouselSlide__3npwv styles_slideWidth__1X5an"
            data-slide-number="3"
            style="
              scroll-snap-align: start;
              margin-right: 17px;
              margin-left: 17px;
            "
          >
            <div class="c a af">
              <div class="styles_container__1r8ex">
                <div
                  style="
                    display: inline-block;
                    max-width: 100%;
                    overflow: hidden;
                    position: relative;
                    box-sizing: border-box;
                    margin: 0;
                  "
                >
                  <div
                    style="
                      box-sizing: border-box;
                      display: block;
                      max-width: 100%;
                    "
                  >
                    <img
                      style="
                        max-width: 100%;
                        display: block;
                        margin: 0;
                        border: none;
                        padding: 0;
                      "
                      alt=""
                      aria-hidden="true"
                      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjg4IiBoZWlnaHQ9IjIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiLz4="
                    />
                  </div>
                  <img
                    alt="Step 3"
                    src="/calculator/trade-price-checker/03.webp"
                    decoding="async"
                    data-nimg="intrinsic"
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      bottom: 0;
                      right: 0;
                      box-sizing: border-box;
                      padding: 0;
                      border: none;
                      margin: auto;
                      display: block;
                      width: 0;
                      height: 0;
                      min-width: 100%;
                      max-width: 100%;
                      min-height: 100%;
                      max-height: 100%;
                    "
                  /><noscript
                    ><img
                      alt="Step 3"
                      src="/calculator/trade-price-checker/03.webp"
                      decoding="async"
                      data-nimg="intrinsic"
                      style="
                        position: absolute;
                        top: 0;
                        left: 0;
                        bottom: 0;
                        right: 0;
                        box-sizing: border-box;
                        padding: 0;
                        border: none;
                        margin: auto;
                        display: block;
                        width: 0;
                        height: 0;
                        min-width: 100%;
                        max-width: 100%;
                        min-height: 100%;
                        max-height: 100%;
                      "
                      loading="eager"
                  /></noscript>
                </div>
                <h4 class="styles_step__1U9zH">Step 3</h4>
                <h2 class="styles_title__2GjHQ">Enter Details</h2>
                <p class="styles_info__ed6IV">
                  If you have the Scrip name and trade price, input these
                  details and hit "Search".
                </p>
              </div>
            </div>
          </div>
          <div
            class="styles_carouselSlide__3npwv styles_slideWidth__1X5an"
            data-slide-number="4"
            style="
              scroll-snap-align: start;
              margin-right: 17px;
              margin-left: 17px;
            "
          >
            <div class="c a af">
              <div class="styles_container__1r8ex">
                <div
                  style="
                    display: inline-block;
                    max-width: 100%;
                    overflow: hidden;
                    position: relative;
                    box-sizing: border-box;
                    margin: 0;
                  "
                >
                  <div
                    style="
                      box-sizing: border-box;
                      display: block;
                      max-width: 100%;
                    "
                  >
                    <img
                      style="
                        max-width: 100%;
                        display: block;
                        margin: 0;
                        border: none;
                        padding: 0;
                      "
                      alt=""
                      aria-hidden="true"
                      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjg4IiBoZWlnaHQ9IjIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiLz4="
                    />
                  </div>
                  <img
                    alt="Step 4"
                    src="/calculator/trade-price-checker/04.webp"
                    decoding="async"
                    data-nimg="intrinsic"
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      bottom: 0;
                      right: 0;
                      box-sizing: border-box;
                      padding: 0;
                      border: none;
                      margin: auto;
                      display: block;
                      width: 0;
                      height: 0;
                      min-width: 100%;
                      max-width: 100%;
                      min-height: 100%;
                      max-height: 100%;
                    "
                  /><noscript
                    ><img
                      alt="Step 4"
                      src="/calculator/trade-price-checker/04.webp"
                      decoding="async"
                      data-nimg="intrinsic"
                      style="
                        position: absolute;
                        top: 0;
                        left: 0;
                        bottom: 0;
                        right: 0;
                        box-sizing: border-box;
                        padding: 0;
                        border: none;
                        margin: auto;
                        display: block;
                        width: 0;
                        height: 0;
                        min-width: 100%;
                        max-width: 100%;
                        min-height: 100%;
                        max-height: 100%;
                      "
                      loading="eager"
                  /></noscript>
                </div>
                <h4 class="styles_step__1U9zH">Step 4</h4>
                <h2 class="styles_title__2GjHQ">Access Results</h2>
                <p class="styles_info__ed6IV">
                  The tool presents a graphical and tabular breakdown of price
                  hits for the chosen scrip throughout that trading day.
                </p>
              </div>
            </div>
          </div>
          <div
            class="styles_carouselSlide__3npwv styles_slideWidth__1X5an"
            data-slide-number="5"
            style="
              scroll-snap-align: start;
              margin-right: 17px;
              margin-left: 17px;
            "
          >
            <div class="c a af">
              <div class="styles_container__1r8ex">
                <div
                  style="
                    display: inline-block;
                    max-width: 100%;
                    overflow: hidden;
                    position: relative;
                    box-sizing: border-box;
                    margin: 0;
                  "
                >
                  <div
                    style="
                      box-sizing: border-box;
                      display: block;
                      max-width: 100%;
                    "
                  >
                    <img
                      style="
                        max-width: 100%;
                        display: block;
                        margin: 0;
                        border: none;
                        padding: 0;
                      "
                      alt=""
                      aria-hidden="true"
                      src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjg4IiBoZWlnaHQ9IjIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiLz4="
                    />
                  </div>
                  <img
                    alt="Step 5"
                    src="/calculator/trade-price-checker/05.webp"
                    decoding="async"
                    data-nimg="intrinsic"
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      bottom: 0;
                      right: 0;
                      box-sizing: border-box;
                      padding: 0;
                      border: none;
                      margin: auto;
                      display: block;
                      width: 0;
                      height: 0;
                      min-width: 100%;
                      max-width: 100%;
                      min-height: 100%;
                      max-height: 100%;
                    "
                  /><noscript
                    ><img
                      alt="Step 5"
                      src="/calculator/trade-price-checker/05.webp"
                      decoding="async"
                      data-nimg="intrinsic"
                      style="
                        position: absolute;
                        top: 0;
                        left: 0;
                        bottom: 0;
                        right: 0;
                        box-sizing: border-box;
                        padding: 0;
                        border: none;
                        margin: auto;
                        display: block;
                        width: 0;
                        height: 0;
                        min-width: 100%;
                        max-width: 100%;
                        min-height: 100%;
                        max-height: 100%;
                      "
                      loading="eager"
                  /></noscript>
                </div>
                <h4 class="styles_step__1U9zH">Step 5</h4>
                <h2 class="styles_title__2GjHQ">Exchange No. Search</h2>
                <p class="styles_info__ed6IV">
                  Alternatively, if you have the Exchange No or Exchange Order
                  ID input it in the designated field and click "Search" to view
                  the trade details.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="styles_controls__36VHe a">
        <button
          type="button"
          class="styles_investingBtn__2aDfP at e f x y c av ab aw i a ae af ag ah ai az ba bb bc bd be bf n bg bh bi"
        >
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            class="styles_link__1FbsV"
            >Start Trading</a
          >
        </button>
        <div
          class="styles_arrowContainer__3iSa6 styles_truthsCarouselArrows__3Dnhp"
        >
          <button class="styles_carouselArrow__1rqpy styles_disabled__4N7o0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
              class="styles_arrowDisabled__3W8Vz q ia ib"
            >
              <defs></defs>
              <path
                stroke="currentColor"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              ></path>
            </svg></button
          ><button class="styles_carouselArrow__1rqpy">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
              class="q ia ib"
            >
              <defs></defs>
              <path
                stroke="currentColor"
                stroke-width="2"
                d="M9 5l7 7-7 7"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="styles_banner__24s3r">
    <div class="styles_tbtImage__u3yW6"></div>
    <div class="styles_infoContainer__uiUz_">
      <div class="styles_title__3AzLR">Complete Transparency</div>
      <div class="styles_desc__3Nffq">
        Trade Price Checker is a part of the TBT Engine suite and it helps you
        verify your trades across any broker
      </div>
      <button
        type="button"
        class="styles_LearMoreButton__3v2Di at e f x y c av ab aw i a ae af ag ah ai az ie bb bc bd be bf n bg bh bi"
      >
        <a
          href="/tick-by-tick-trading/"
          target="_blank"
          rel="noreferrer"
          class="styles_link__2p8rM"
          >Learn More</a
        >
      </button>
    </div>
  </div>
  <div class="styles_container__20AvH">
    <div class="styles_content__2wiDg">
      <div class="styles_actions__1TEFE">
        <button
          type="button"
          class="styles_Button__2iWJU at e f x y c av ab aw i a ae af ag ah ai az ba bb bc bd be bf n bg bh bi"
        >
          <a
            href="https://wa.me/+917092362098"
            rel="noreferrer"
            class="styles_link__3PDhT"
            >Open a Demat Account</a
          ></button
        ><button
          type="button"
          style="border-color: red !important"
          class="styles_signIn__H5xw5 q e f x y c z ab ac i a ae af ag ah ai aj ak al am an ao m n ap aq o"
        >
          <a
            href="#login"
            rel="noreferrer"
            class="styles_link__3PDhT"
            >Sign in</a
          >
        </button>
      </div>
    </div>
  </div>
</template>


<style data-fela-rehydration="237" data-fela-type="RULE">
.a {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.b {
  margin-bottom: 64px;
}

.c {
  align-items: center;
  -webkit-box-align: center;
}

.d {
  color: #5a298b;
}

.e {
  font-family: "Messina Sans", "Helvetica", "Arial", sans-serif;
}

.f {
  font-size: 14px;
}

.g {
  font-weight: 700;
}

.h {
  line-height: 1.7;
}

.i {
  cursor: pointer;
}

.j {
  text-decoration: underline !important;
}

.m:disabled {
  color: #d0d0d0;
}

.n:disabled {
  cursor: not-allowed;
}

.o:disabled:hover {
  color: #d0d0d0;
}

.p {
  margin: 0px 16px 0px 0px;
}

.q {
  color: #262626;
}

.r {
  height: 20px;
}

.s {
  width: 20px;
}

.t > a {
  box-shadow: 0px 0px 0px 1px #5a298b inset;
}

.u > a {
  color: #5a298b;
}

.v > a:hover {
  background: #7132b0 !important;
}

.w > a:hover {
  color: #fff;
}

.x {
  font-weight: bold;
}

.y {
  line-height: 1;
}

.z {
  background: #ffffff;
}

.ab {
  border-radius: 24px;
}

.ac {
  box-shadow: 0px 0px 0px 1px #d0d0d0 inset;
}

.ae {
  height: 48px;
}

.af {
  justify-content: center;
  -webkit-box-pack: center;
}

.ag {
  outline: none;
}

.ah {
  padding: 0px 24px;
}

.ai {
  transition: color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
  -webkit-transition: color 0.2s ease, background 0.2s ease,
    box-shadow 0.2s ease;
  -moz-transition: color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.an:disabled {
  background: inherit;
}

.ao:disabled {
  box-shadow: 0px 0px 0px 1px #d0d0d0 inset;
}

.ap:disabled:hover {
  background: inherit;
}

.aq:disabled:hover {
  box-shadow: 0px 0px 0px 1px #d0d0d0 inset;
}

.ar {
  font-weight: 400;
}

.as {
  margin: 0px 16px 0px 16px;
}

.at {
  color: #ffffff;
}

.au {
  font-size: 12px;
}

.av {
  background: #5a298b;
}

.aw {
  box-shadow: none;
}

.ax {
  height: 32px;
}

.ay {
  padding: 0px 16px;
}

.bd:disabled {
  background: #f2f2f2;
}

.be:disabled {
  box-shadow: none;
}

.bf:disabled {
  color: #aeaeae;
}

.bg:disabled:hover {
  background: #f2f2f2;
}

.bh:disabled:hover {
  box-shadow: none;
}

.bi:disabled:hover {
  color: #aeaeae;
}

.bj {
  flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
}

.bk {
  margin: auto;
}

.bl {
  width: 960px;
}

.bq {
  padding-top: 16px;
}

.br {
  line-height: 16px;
}

.bs {
  color: #6a6a6a;
}

.bt {
  gap: 50px;
}

.bw {
  display: block;
}

.bx {
  width: 600px;
}

.by {
  padding-top: 12px;
}

.bz {
  padding-bottom: 8px;
}

.ca {
  font-size: 32px;
}

.cb {
  font-weight: 600;
}

.cc {
  width: 100%;
}

.cd {
  margin-bottom: 8px;
}

.cf {
  font-weight: 500;
}

.cg {
  line-height: 20px;
}

.ch {
  padding-top: 32px;
}

.ci {
  color: #101010;
}

.cm {
  justify-content: space-between;
  -webkit-box-pack: justify;
}

.cn {
  margin-bottom: 16px;
}

.co {
  gap: 12px;
}

.cp {
  width: 352px;
}

.cr {
  opacity: 1;
}

.ct {
  color: #ce3a3a;
}

.cu {
  overflow: hidden;
}

.cv {
  border-radius: 8px;
}

.cw {
  border: 1px solid #b1b1b1;
}

.cx {
  color: text1;
}

.da {
  background-color: #f2f2f2;
}

.db > div {
  width: 100%;
}

.dc > div {
  padding-right: 0px;
}

.dd {
  color: #aeaeae;
}

.de {
  height: 40px;
}

.df {
  position: relative;
}

.dg {
  z-index: 0;
}

.dh > * + * {
  margin-left: 8px;
}

.di {
  display: -webkit-inline-box;
  display: -moz-inline-box;
  display: -ms-inline-flexbox;
  display: -webkit-inline-flex;
  display: inline-flex;
}

.dj {
  margin: -6px;
}

.dk {
  height: calc(100% + 12px);
}

.dl {
  width: calc(100% + 12px);
}

.dm > * {
  margin: 6px;
}

.dn {
  line-height: 1.42;
}

.do::placeholder {
  color: #aeaeae;
}

.dp::placeholder {
  opacity: 1;
}

.dq + div {
  background: #f2f2f2;
}

.dr + div {
  box-shadow: ;
}

.ds:disabled + div {
  background: #f2f2f2;
}

.dt:disabled + div {
  box-shadow: ;
}

.dx:-internal-autofill-selected {
  box-shadow: 0px 0px 0px 30px #f2f2f2 inset;
}

.dy {
  flex: 1 1 auto;
}

.dz {
  background: #f2f2f2;
}

.ea {
  bottom: 0;
}

.eb {
  left: 0;
}

.ec {
  margin: 0 !important;
}

.ed {
  pointer-events: none;
}

.ee {
  position: absolute;
}

.ef {
  right: 0;
}

.eg {
  top: 0;
}

.eh {
  transition: box-shadow 0.2s ease;
  -webkit-transition: box-shadow 0.2s ease;
  -moz-transition: box-shadow 0.2s ease;
}

.ei {
  z-index: -1;
}

.ej {
  flex-direction: row-reverse;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
}

.ek {
  margin: 0px 0px 16px 0px;
}

.el {
  font-style: normal;
}

.em {
  color: #444;
}

.en {
  padding: 18px 0px 8px 0px;
}

.eo {
  margin: -4px;
}

.ep {
  height: calc(100% + 8px);
}

.eq {
  width: calc(100% + 8px);
}

.er > * {
  margin: 4px;
}

.es {
  display: inline-block;
}

.et {
  font-size: 22px;
}

.eu {
  height: 22px;
}

.ev {
  width: 22px;
}

.ew {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.ex {
  color: transparent;
}

.ey {
  height: 100%;
}

.ez {
  margin: 0;
}

.fa {
  z-index: 2;
}

.fb ~ svg {
  color: #e1e1e1;
}

.fc ~ svg {
  height: 100%;
}

.fd ~ svg {
  position: absolute;
}

.fe ~ svg {
  transition: transform 0.2s ease;
  -webkit-transition: transform 0.2s ease;
  -moz-transition: transform 0.2s ease;
}

.ff ~ svg {
  width: 100%;
}

.fg + svg,
~ svg {
  height: 100%;
}

.fh + svg,
~ svg {
  width: 100%;
}

.fi:checked ~ svg {
  color: #5a298b;
}

.fj:disabled ~ svg {
  color: #d0d0d0;
}

.fk:not(:checked) ~ svg:last-of-type {
  transform: scale(0);
}

.fl {
  height: 1em;
}

.fm {
  width: 1em;
}

.fn {
  margin: 0px 0px 8px 0px;
}

.fo > div:first-child {
  width: 100%;
}

.fp > div:first-child {
  padding-right: 0px;
}

.fq {
  height: 16px;
}

.fr {
  width: 16px;
}

.fs {
  width: 45px;
}

.ft {
  margin: 16px 0px 16px 0px;
}

.fu {
  margin: -8px;
}

.fv {
  height: calc(100% + 16px);
}

.fw {
  width: calc(100% + 16px);
}

.fx > * {
  margin: 8px;
}

.fy {
  border: 0;
}

.fz {
  border-bottom: 1px solid #6a6a6a;
}

.ga {
  font-size: 10px;
}

.gb {
  padding: 0px 0px 8px 0px;
}

.gc {
  align-items: flex-end;
  -webkit-box-align: end;
}

.gd {
  margin: -3px;
}

.ge {
  height: calc(100% + 6px);
}

.gf {
  width: calc(100% + 6px);
}

.gg > * {
  margin: 3px;
}

.gh {
  opacity: 0.3;
}

.gi {
  color: white;
}

.gj {
  border: 1px solid #d0d0d0;
}

.gk {
  padding: 12px 0px 0px 0px;
}

.gl {
  width: 956px;
}

.gq {
  border-bottom: 1px solid #b1b1b1;
}

.gr {
  padding: 2% 0;
}

.gs {
  max-width: 800px;
}

.gt {
  opacity: 0.5;
}

.gu {
  border-radius: 4px;
}

.gv {
  border: 0.5px solid #b1b1b1;
}

.gw {
  border-collapse: collapse;
}

.gx {
  border-spacing: 0;
}

.gy {
  table-layout: auto;
}

.gz caption {
  color: #262626;
}

.ha caption {
  font-family: "Messina Sans", "Helvetica", "Arial", sans-serif;
}

.hb caption {
  font-size: 12px;
}

.hc caption {
  font-weight: 400;
}

.hd caption {
  line-height: 1.33;
}

.he caption {
  caption-side: top;
}

.hf caption {
  padding: 12px;
}

.hg caption {
  text-align: left;
}

.hh {
  display: table-header-group;
}

.hi > tr {
  box-shadow: 0px -1px 0px #d0d0d0 inset;
}

.hj > tr > th:not(:last-child):not(:first-child) {
  box-shadow: 0px -1px 0px #d0d0d0 inset;
}

.hk > th {
  box-shadow: rgb(208, 208, 208) 0px -1px 0px inset;
}

.hl {
  background-color: #f5f5f5;
}

.hm {
  gap: 40px;
}

.ho {
  display: table-cell;
}

.hp {
  padding: 12px;
}

.hq {
  text-align: left;
}

.hr {
  display: table-row-group;
}

.hs {
  gap: 80px;
}

.ht {
  border-bottom: 1px solid #e5e5e5;
}

.hv {
  padding: 15px;
}

.hx {
  margin-left: auto;
}

.hy {
  padding-right: 12px;
}

.hz {
  border-bottom: 1px solid #e0e0e0;
}

.ia {
  height: 24px;
}

.ib {
  width: 24px;
}

.ic {
  color: #c6c6c6;
}

.id {
  line-height: 1.33;
}

.l:hover {
  color: #7a26ce;
}

.al:hover {
  background: #ffffff;
}

.am:hover {
  box-shadow: 0px 0px 0px 1px #5a298b inset;
}

.bb:hover {
  background: #7a26ce;
}

.bc:hover {
  box-shadow: none;
}

.cy:hover {
  background: #f2f2f2;
}

.dw:hover:not(:disabled) + div {
  box-shadow: ;
}

.du:focus:not(:disabled) {
  outline: none;
}

.dv:focus:not(:disabled) + div {
  box-shadow: 0px 0px 0px 1px #7a26ce;
}

.k:active {
  color: #280b45;
}

.aj:active {
  background: #e1e1e1;
}

.ak:active {
  box-shadow: 0px 0px 0px 1px transparent inset;
}

.az:active {
  background: #280b45;
}

.ba:active {
  box-shadow: ;
}
</style>
        <style media="(max-width: 1024px)" data-fela-rehydration="237" data-fela-type="RULE">
.bm {
  width: 600px;
}

.cz {
  width: 40%;
}

.go {
  margin: auto;
}
</style>
        <style media="(max-width:768px)" data-fela-rehydration="237" data-fela-type="RULE">
.bn {
  width: 100%;
}

.bo {
  overflow: hidden;
}

.bp {
  padding-left: 12px;
}

.bu {
  width: 100vw;
}

.bv {
  padding-right: 12px;
}

.ce {
  font-size: 32px;
}

.cj {
  font-size: 14px;
}

.ck {
  padding-top: 16px;
}

.cl {
  padding-bottom: 12px;
}

.cq {
  width: 60%;
}

.cs {
  font-size: 12px;
}
</style>
        <style media="(max-width: 1024px) and (min-width: 768px)" data-fela-rehydration="237" data-fela-type="RULE">
.gm {
  width: 100vw;
}
</style>
        <style media="(max-width: 767px)" data-fela-rehydration="237" data-fela-type="RULE">
.gn {
  width: 100vw;
}

.gp {
  padding: 16px 12px;
}

.hn {
  gap: 10px;
}

.hu {
  gap: 60px;
}

.hw {
  padding: 8px;
}
</style>
